import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/contractor-fee-calculator',
  component: () => import('../../routes/ContractorFeeCalculator.svelte'),
  card: {
    id: 'contractor-fee-calculator',
    title: 'Contractor Fee Calculator',
    description: 'Calculate contractor fees, subcontractor costs, materials, overhead, and taxes to determine the true project cost.',
    icon: 'construction',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/contractor-fee-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Contractor Fee Calculator – Estimate True Project Cost',
    description: 'Calculate contractor fees, subcontractor costs, materials, overhead, and taxes. Get a complete breakdown of what a construction or renovation project really costs.',
  },
};

export default meta;